import { Link } from "react-router-dom";
import "./about-block.scss";

export default function AboutBlock({
  title,
  subTitle,
  content,
  buttonText,
  as = "",
  href = "",
}) {
  return (
    <div id="about-block">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 data-container">
            <div className="row justify-content-center">
              <div className="col-md-6 data">
                {subTitle && <h4>{subTitle}</h4>}
                <h3>{title}</h3>
                {content && <p dangerouslySetInnerHTML={{ __html: content }} />}
                <Link to={href} as={as}>
                    <button className="round black" aria-label="round-black">{buttonText}</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
